import { normalizeCellString } from ".";

export const getImportReference = (
  value: string | number | null | undefined,
): string | null => normalizeCellString(value);

export const buildImportResultMessage = (
  entityName: string,
  createdCount: number,
  failedReferences: string[],
) =>
  `Se crearon ${createdCount} ${entityName} y no se crearon ${failedReferences.length} ${entityName}${
    failedReferences.length > 0 ? ` (${failedReferences.join(", ")})` : ""
  }.`;
